import React, { Component } from 'react';
import { Modal, Button, Form, Message, Icon, Checkbox } from 'semantic-ui-react'

import { getText } from '../helpers';
import history from '../history';

class SavePlanAsModal extends Component {
  constructor(props){
    super(props);

    this.state = {
      planName: "",
      isTemplate: false,
      invalidPlanName: false
    }
  }

  onChangePlanName = (value) => {
    this.setState({
      planName: value,
    })
  }

  onChangeCheckbox = (data) => {
    this.setState({
      isTemplate: data.checked
    })
  }

  onSavePlanAs = () => {
    if(this.state.planName.length === 0) {
      this.setState({
        invalidPlanName: true,
      })
      return
    }
    this.props.saveAsNewPlan(this.state.planName, this.state.isTemplate)
  }

  redirectToTemplates = () => {
    history.push("/dashboard/risk_templates")
  }

  copyingPlanMessage = () => (
    <Message icon info>
      <Icon name='loading circle notched icon' loading />
      <Message.Content>
        { 
          this.state.isTemplate ? "Please wait while we create the template for you. This may take a minute so please hold on."
          : "Please wait while we create the plan for you. This may take a minute so please hold on."
        }
      </Message.Content>
    </Message>
  )

  copyingPlanSuccess = () => (
    <Message icon success>
      <Message.Content>
        {
          this.state.isTemplate ? 
          <span>The template has been successfully created. <span class="link text-light-blue" onClick={this.redirectToTemplates}>Click here to see the new template</span></span>
          : "The plan has been successfully created."
        }
      </Message.Content>
    </Message>
  )

  render() {
    const { enter_plan_name, save } = this.props.translations
    const { loadingState, shown, trigger, onClose, plan, copyingSuccess } = this.props;
    const { invalidPlanName, isTemplate } = this.state;
    const deleteIconClass = loadingState ? "delete icon disabled" : "delete icon";
    const instruction = isTemplate ? getText("Enter Template name") : enter_plan_name;
    return (
      <Modal trigger={ trigger } size={ 'tiny' } open={ shown }>
        <Modal.Header>{ copyingSuccess ? getText("Success") : getText("Save As") }</Modal.Header>
        <Modal.Content>
        { 
          copyingSuccess ?
          this.copyingPlanSuccess()
          :
          <Form>
            <Form.Input
              fluid
              disabled={loadingState}
              label={instruction}
              placeholder={instruction}
              defaultValue={ plan.name }
              onChange={ (target, { value }) => this.onChangePlanName(value) }
              error={ invalidPlanName }
            />
            <Checkbox disabled={loadingState} label='Save as template' onChange={ (target, data ) => this.onChangeCheckbox(data) }/>
            { loadingState && this.copyingPlanMessage() }
          </Form>
        }
        </Modal.Content>
        <Modal.Actions>
          {
            copyingSuccess ?
            <Button basic onClick={ onClose }>Close</Button>
            : 
            <Button
              disabled={loadingState}
              color='teal'
              content={<span>{save}</span>}
              fluid
              size='medium'
              className="new-plan-button"
              onClick={ () => this.onSavePlanAs() }
            />
          }
        </Modal.Actions>
        <i className={deleteIconClass} onClick={ onClose }></i>
      </Modal>
    )
  }
}

export default SavePlanAsModal



// WEBPACK FOOTER //
// ./src/components/save_plan_as_modal.js